<script>
export default {}
</script>

<template>
  <div>
    <slot></slot>
    <div :class="$style.contentContainer">
      <slot name="content" />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
